<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_visits']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end" v-if="userData.permissions['new_patient'] == 1">
              <b-button size="sm" variant="info" @click="openImportPatientsModal">
                <i class="mdi mdi-file-import"></i> Import Patients
              </b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(age)="data">
                {{ data.item.age }} 
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(appuserid)="data">
                {{ data.item.appusers.id }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <router-link :to="{ path: '/profile',  query: { id: data.item.patient_id }}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-eye"></i></router-link>
                <b-button @click="edit(data.item.id,data.item.name,data.item.gender,data.item.telephone,data.item.nationality,data.item.address,data.item.date_of_birth,data.item.nokname,data.item.nokcontact )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                <span v-show="data.item.appuser_id == null">
                  <b-button @click="update(data.item.id,data.item.name,appuserid)" type="button" class="btn-sm btn" variant="secondary"  v-b-modal.update> <i class="mdi mdi-update"></i> </b-button>
                  <!-- <b-button @click="update(data.item.id,data.item.name,data.item.telephone,data.item.address,data.item.emailaddress)" type="button" class="btn-sm btn" variant="secondary"  v-b-modal.update> <i class="mdi mdi-update"></i> </b-button> -->

                </span>

                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients</span></center>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-patient" centered title="Edit Patient" title-class="font-14" hide-footer>
        <form @submit.prevent="editPatient">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient Name</label>
            <input v-model="name" type="text" class="form-control" />
            <label>Gender</label>
              <select class="form-control" v-model="gender">
                <option>Female</option>
                <option>Male</option>
              </select>
            <label>Telephone</label>
            <input v-model="telephone" type="text" class="form-control" />
            <label>Date Of Birth</label>
            <input v-model="dateofbirth" type="date" class="form-control" />
            <label>Nationality</label>
            <input v-model="nationality" type="text" class="form-control" />
            <label>Address</label>
            <input v-model="address" type="text" class="form-control" />
            <label>Next of Kin</label>
            <input v-model="nokname" type="text" class="form-control" />
            <label>Next of Kin Contact</label>
            <input v-model="nokcontact" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-patient')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
    <b-modal id="update-patient" centered title="Make Patient App User" title-class="font-14" hide-footer>
  <form @submit.prevent="updatePatient">
    <div class="form-group mb-2">
      <input v-model="id" type="hidden">
      
      <label>Patient Name</label>
      <!-- Multiselect component to choose the appuser by email address -->
      <multiselect v-model="appuser" :options="appusers"  :custom-label="customLabel"  track-by="emailaddress"></multiselect>
      
      <!-- Hidden input for appuser ID, which will be set based on the selected appuser -->
      <input v-model="appuserid" type="hidden">
    </div>
    <div class="form-group d-flex justify-content-end">
      <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('update-patient')">Close</b-button>
      <b-button type="submit" class="btn ms-1 w-30" variant="primary">
        <i class="fas fa-check-circle"></i> Submit
      </b-button>
    </div>
  </form>
</b-modal>



    <b-modal id="delete-patient" centered title="Delete Patient" title-class="font-18" hide-footer>
        <form @submit.prevent="removePatient">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Patient : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-patient')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="import-patients" centered title="Import Patients" title-class="font-18" hide-footer>
      <form
        @submit.prevent="importPatientsFile"
        class="import-modal-drop-target"
        :class="{ 'drag-over': isDragOver }"
        @dragenter.prevent="onImportDragEnter"
        @dragover.prevent="onImportDragOver"
        @dragleave.prevent="onImportDragLeave"
        @drop.prevent="onImportDrop"
      >
        <div class="alert alert-info">
          <h6 class="alert-heading mb-2">Rules</h6>
          <ul class="mb-0 ps-3">
            <li>Use the template file from this popup.</li>
            <li>Required columns: <code>name</code>, <code>gender</code>, <code>date_of_birth</code>, <code>nationality</code>, <code>address</code>, <code>telephone</code>.</li>
            <li>Optional columns: <code>nin</code>.</li>
            <li>Accepted gender: Male/Female or M/F or 1/2.</li>
            <li>Date format: YYYY-MM-DD or DD/MM/YYYY.</li>
            <li>Telephone: digits only, at least 9 digits. In Excel, set the telephone column to Text.</li>
          </ul>
        </div>

        <div class="form-group mb-3">
          <b-button type="button" variant="outline-primary" @click="downloadPatientTemplate" :disabled="isImporting">
            <i class="mdi mdi-download"></i> Download Template
          </b-button>
        </div>

        <div class="form-group mb-3" v-if="!selectedImportFile">
          <label>Upload Completed Template *</label>
          <input
            ref="patientImportFile"
            type="file"
            class="form-control"
            accept=".csv,.xlsx,.xls"
            @change="handlePatientFileUpload"
            :disabled="isImporting"
          />
          <small class="text-muted">Accepted formats: .xlsx, .xls, .csv (Max 5MB)</small>
          <small class="text-muted d-block mt-1">You can also drag and drop your Excel/CSV file anywhere in this popup.</small>
        </div>

        <div v-else class="mb-3">
          <b-badge class="bg-info">
            <i class="mdi mdi-file"></i> {{ selectedImportFile.name }}
          </b-badge>
          <b-button size="sm" variant="link" class="ms-2 p-0" @click="clearPatientImportFile" :disabled="isImporting">
            Remove
          </b-button>
        </div>

        <div v-if="importMessage" class="alert" :class="importSuccess ? 'alert-success' : 'alert-danger'">
          {{ importMessage }}
        </div>

        <div v-if="importErrors.length" class="alert alert-danger">
          <h6 class="mb-2">Please fix the following:</h6>
          <ul class="mb-0 ps-3">
            <li v-for="(error, index) in importErrors" :key="index">{{ error }}</li>
          </ul>
        </div>

        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('import-patients')" :disabled="isImporting">
            Close
          </b-button>
          <b-button
            v-if="!hasImportResponse"
            type="submit"
            class="btn ms-1 w-30"
            variant="primary"
            :disabled="!selectedImportFile || isImporting"
          >
            <template v-if="isImporting">
              <b-spinner small></b-spinner> Uploading...
            </template>
            <template v-else>
              <i class="fas fa-upload"></i> Upload & Import
            </template>
          </b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientMethods, patientComputed, appuserMethods, appuserComputed } from "@/state/helpers";

export default {
  page: {
    title: "View Patients",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
    // Layout,PageHeader

  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Patients",
      items: [ {text: "Dashboard",to: "/",}, {text: "View Patients",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'age', label: 'Age', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'nationality', label: 'Nationality', visible: true },
          { key: 'address', label: 'Address', visible: true }, 
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'addedon', label: 'Added on', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      telephone:'',
      name:'',
      nationality:'',
      gender:'',
      nokcontact:'',
      nokname:'',
      address:'',
      dateofbirth:'',
      appuser:[],
      appuserid:'',
      emailaddress:'',
      selectedImportFile: null,
      isImporting: false,
      hasImportResponse: false,
      importErrors: [],
      importMessage: '',
      importSuccess: false,
      isDragOver: false,
    };
  },
  watch: {
    // Whenever the selected appuser changes, update the appuserid accordingly
    appuser(newVal) {
      if (newVal) {
        // When a new appuser is selected, store its ID
        this.appuserid = newVal.id;
      } else {
        // Reset the appuserid if no appuser is selected
        this.appuserid = null;
      }
    }
  },
  computed: {
    ...patientComputed,
    ...appuserComputed,
    List() { return this.patients.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patients.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.patients.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchPatients();
    this.fetchAppUsers();
    this.TotalRows = this.patients.length;
    this.isBusy=false;
  },
  methods: {
    ...patientMethods,
    ...appuserMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name,gender,telephone,nationality,address,dateofbirth,nokcontact,nokname){
      this.id=id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      this.nationality=nationality;
      this.address=address;
      this.nokcontact=nokcontact;
      this.nokname=nokname;
      this.dateofbirth=dateofbirth;
      this.$bvModal.show('edit-patient')
    },

    // update(id,name,telephone,address,emailaddress){
    //   this.id=id;
    //   this.name=name;
    //   this.telephone=telephone;
    //   this.address=address;
    //   this.emailaddress=emailaddress;
    //   this.$bvModal.show('update-patient')
    // },
    update(id, name, appuserid) {
  this.id = id;
  this.name = name;

  // Find the appuser in the appusers array based on appuserid
  const selectedAppUser = this.appusers.find(user => user.id === appuserid);
  
  if (selectedAppUser) {
    this.appuser = selectedAppUser;  // Set the selected appuser
    this.appuserid = selectedAppUser.id;  // Also set the appuserid
  } else {
    this.appuser = null;  // Reset if no match is found
    this.appuserid = null;
  }

  this.$bvModal.show('update-patient');
},

    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-patient')
    },
    openImportPatientsModal() {
      this.clearPatientImportFile();
      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.hasImportResponse = false;
      this.$bvModal.show('import-patients');
    },
    handlePatientFileUpload(event) {
      const file = event.target.files[0];
      this.processImportFile(file);
    },
    processImportFile(file) {
      if (!file) {
        this.clearPatientImportFile();
        return;
      }

      const validExtensions = ['.csv', '.xls', '.xlsx'];
      const isValidExtension = validExtensions.some((ext) => file.name.toLowerCase().endsWith(ext));
      if (!isValidExtension) {
        this.importErrors = ['Please upload a valid Excel/CSV file (.xlsx, .xls, .csv).'];
        this.clearPatientImportFile();
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.importErrors = ['File size must not exceed 5MB.'];
        this.clearPatientImportFile();
        return;
      }

      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.selectedImportFile = file;
    },
    onImportDragEnter() {
      if (this.isImporting || this.selectedImportFile) {
        return;
      }
      this.isDragOver = true;
    },
    onImportDragOver() {
      if (this.isImporting || this.selectedImportFile) {
        return;
      }
      this.isDragOver = true;
    },
    onImportDragLeave() {
      this.isDragOver = false;
    },
    onImportDrop(event) {
      if (this.isImporting || this.selectedImportFile) {
        return;
      }
      this.isDragOver = false;
      const file = event.dataTransfer?.files?.[0] || null;
      this.processImportFile(file);
    },
    clearPatientImportFile() {
      this.selectedImportFile = null;
      this.isDragOver = false;
      if (this.$refs.patientImportFile) {
        this.$refs.patientImportFile.value = '';
      }
    },
    async downloadPatientTemplate() {
      try {
        const response = await axios.get('/patients-import-template', { responseType: 'blob' });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'patients_import_template.xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.importSuccess = false;
        this.importMessage = 'Failed to download the template. Please try again.';
      }
    },
    async importPatientsFile() {
      if (!this.selectedImportFile || this.isImporting) {
        return;
      }

      this.isImporting = true;
      this.importErrors = [];
      this.importMessage = '';
      this.importSuccess = false;
      this.hasImportResponse = false;

      const formData = new FormData();
      formData.append('file', this.selectedImportFile);

      try {
        const response = await axios.post('/patients-import', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.importSuccess = true;
        this.importMessage = response.data.message || 'Patients imported successfully.';
        this.importErrors = [];
        this.hasImportResponse = true;
        this.clearPatientImportFile();
        await this.fetchPatients();
      } catch (error) {
        const responseData = error.response?.data || {};
        this.importSuccess = false;
        this.importMessage = responseData.message || 'Import failed. Please check your file and try again.';
        if (Array.isArray(responseData.errors)) {
          this.importErrors = responseData.errors;
        } else if (responseData.errors && typeof responseData.errors === 'object') {
          this.importErrors = Object.values(responseData.errors).flat();
        } else {
          this.importErrors = [];
        }
        this.hasImportResponse = true;
      } finally {
        this.isImporting = false;
      }
    },
    customLabel(option) {
      // Return the name and email together in one string
      return `${option.name} - ${option.contact} - ${option.emailaddress}`;
    },
    async editPatient(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    formData.append("gender", this.gender);
    formData.append("telephone", this.telephone);
    formData.append("nationality", this.nationality);
    formData.append("address", this.address);
    formData.append("nokname", this.nokname);
    formData.append("nokcontact", this.nokcontact);
    formData.append("dateofbirth", this.dateofbirth);
    let url = "/updatepatient";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatients();
        this.$bvModal.hide('edit-patient');
        this.name="";
        this.gender="";
        this.nationality="";
        this.telephone="";
        this.address="";
        this.nokcontact="";
        this.nokname="";
        this.dateofbirth="";
      }
    });
    },
    async updatePatient(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    formData.append('appuserid',this.appuserid);
    let url = "/updateappuser";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatients();
        this.$bvModal.hide('update-patient');
        this.name="";
        this.appuserid="";
      }
    });
    },
    // async updatePatient(){ 
    // let formData = new FormData();
    // formData.append("id", this.id);
    // formData.append("name", this.name);
    // formData.append("address", this.address);
    // formData.append("emailaddress", this.emailaddress);
    // formData.append("telephone", this.telephone);
    // let url = "/updateappuser";
    // await axios.post(url, formData).then((response) => {
    //   if (response.status == 200) {
    //     this.fetchPatients();
    //     this.$bvModal.hide('update-patient');
    //     this.name="";
    //     this.telephone="";
    //     this.address="";
    //     this.emailaddress="";
    //    }
    // });
    // },
    async removePatient() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removepatient";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatients();
        this.$bvModal.hide('delete-patient');
      }
    });
    },
  },
};
</script>

<style scoped>
.import-modal-drop-target {
  border: 2px dashed transparent;
  border-radius: 0.5rem;
  padding: 0.25rem;
  transition: all 0.2s ease;
}

.import-modal-drop-target.drag-over {
  border-color: #0d6efd;
  background: #eaf2ff;
}
</style>
